import { IActions, IState } from "./interfaces";
import React, { useEffect, useState } from "react";

import Calculator from "./calculator";
import styled from "styled-components";
import { useReactHookz } from "./state";

export interface PureFlocCalculatorProps {
  language?: string;
  country?: string;
}

const StyledWrapper = styled.div`
  @media (max-width: 600px) {
    .input-field {
      grid-template-columns: 1fr;
    }
  }
`;

export const PureFlocCalculator: React.FC<PureFlocCalculatorProps> = (
  props
) => {
  const [, actions]: [IState, IActions] = useReactHookz();

  useEffect(() => {
    actions.setLanguage(props.language || "nl");
    actions.setCountry(props.country || "BE");
  }, []);

  return (
    <StyledWrapper>
      <Calculator />
    </StyledWrapper>
  );
};
